import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import accounting from 'accounting';
import { Button, Segment, Form, Icon, Modal, Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import {applyCard} from '../../core/apiClient';
import {getConst} from '../../core/consts';
import 'rc-slider/assets/index.css';
//import $ from 'jquery';
import { applySuccess, storeSimulateEmail, storeApplyFormInput } from '../../redux/actions';
import {getStaticText} from '../../core/lang';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import {nationality} from './nationality.js';

class DirectApply extends Component {
  constructor() {
    super();
    this.state = {
      utmSource:'source',
      applyMessage: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailId: '',
      salary: 5000,
      terms: false,
      selfEmployed : false,
      phoneNumberCode: '',
      openApplyResponsePopup: false,
      goodTimeToCall: '',
      nationality: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary: '',
        nationality:'',
      },
      onFocus: '',
      openConfirmPopup: false,
      maxSalary: 50000,
      modalOpen: false
    }
  }

  show = () => this.setState({ openApplyResponsePopup: true })
  close = () => this.setState({ openApplyResponsePopup: false })

  showConfirm = () => {
    if(this.props.data.applyCardObject.contract){
    this.setState({ openConfirmPopup: true });
    } else{
      this.props.data.closeDirectApplyPopup();
    }
  }
  handleConfirm = () => {
    this.setState({ openConfirmPopup: false });
    this.props.data.closeDirectApplyPopup();
  }
   handleCancel = () =>{ 
        this.setState({ openConfirmPopup: false })
 }

  finalCardApply = (utmSource,utmMedium,utmCampaign) => {
    if(utmCampaign===null){
      utmCampaign = 'Nil';
    }
    else{
      utmCampaign = sessionStorage.getItem("utm_campaign")
    }

    if(utmMedium===null){
      utmMedium = 'Nil';
    }
    else{
      utmMedium = sessionStorage.getItem("utm_medium")
    }

    if(utmSource===null){
      utmSource = 'Nil';
    }
    else{
      utmSource = sessionStorage.getItem("utm_source")
    }
    
    let referrer = document.referrer;
    if(referrer===''|| _.isEmpty(referrer)){
      referrer = window.location.href;
    }
    console.log("Request URL:", window.location.href);
    console.log("Referrer URL direct:", referrer);
    const {campaignUrl} = getConst(this.props.activeLanguage);
    const validFirstName = this.handleFirstNameBlur(), validLastName = this.handleLastNameBlur(),
      validEmail = this.handleEmailIdBlur(), validPhone = this.handlePhoneNumberBlur(),
      validTerms = this.handleTermsValidate(), salary = this.handleSalaryBlur(),
      validNationality = this.handleNationalityBlur();
    if (validFirstName && validLastName && validEmail && validPhone && validTerms && salary && validNationality) {
        let email = this.state.emailId;
        if (_.isEmpty(email)) {
          email = this.props.simulateEmail;
        }
        let selfEmployedVal = 'false';

        if(this.state.selfEmployed === true){
          selfEmployedVal = this.state.selfEmployed.toString();
        }
        let goodTimeToCall = 'N/A'
        if(this.state.goodTimeToCall !== ''){
          goodTimeToCall = this.state.goodTimeToCall;
        }
        let productIds = this.props.data.applyCardObject.id
        if(productIds == null){
           productIds = this.props.data.applyCardObject.details["id"]
        } 
        applyCard({
          'customer': {
            'first_name': this.state.firstName,
            'email': email,
            'last_name': this.state.lastName,
            'phone': `+971${this.state.phoneNumberCode}${this.state.phoneNumber}`,
            'salary': this.state.salary,
            'goodTimeToCall': goodTimeToCall,
            'selfEmployed': selfEmployedVal,
            'nationality': this.state.nationality,
            "utm_tracking_details": {
              "utm_source": utmSource,
              "utm_medium": utmMedium,
              "utm_campaign": utmCampaign,
              "request_url": window.location.href,
              "http_referrer": referrer
              }
          },
          'productIds': [productIds]
        }
        ).then((response) => {
          this.props.storeSimulateEmail(email, false);
          this.props.storeApplyFormInput({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumberCode: this.state.phoneNumberCode,
            phoneNumber: this.state.phoneNumber,
            emailId: email,
            salary: this.state.salary,
            selfEmployed: selfEmployedVal,
            nationality: this.state.nationality,
            
          });
          //this.props.history.push("/credit-cards");
          this.closeAllApplyPopup();
          ReactPixel.fbq('track', 'SubmitApplication');
          this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${this.props.data.applyCardObject.id}`);
        }).catch((err) =>{
          this.props.storeSimulateEmail(email, false);
          this.props.storeApplyFormInput({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumberCode: this.state.phoneNumberCode,
            phoneNumber: this.state.phoneNumber,
            emailId: email,
            salary: this.state.salary,
            selfEmployed: selfEmployedVal,
            nationality: this.state.nationality,
            //incomeType: this.state.incomeType,
          });
          //this.props.history.push("/credit-cards");
          this.closeAllApplyPopup();
          const {multiple_apply_error} = getStaticText(this.props.activeLanguage);
          this.props.applySuccess(`${multiple_apply_error}`, true);
          this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${this.props.data.applyCardObject.id}`);
        })
    }
    const cardname = this.props.data.applyCardObject.name
    if(this.props.location.pathname.split('/')[3] === campaignUrl){
      ReactGA.event({
        category: "Credit Card",
        action: 'Bleap FB Campaign No-Anunual-Fee-Credit-Card-Apply Now'
      });
    } else{
      ReactGA.event({
        category: "Card",
        action: cardname+'-ApplyNow'
      });
    }
  }

  handleTerms = (e, {checked}) => {
    this.setState({terms: checked})

  }

  handleSelfEmployed = (e, {checked}) => {
    console.log("Emp:",checked);
    this.setState({selfEmployed: checked})
  }

  handleTermsValidate = () => {
    let valid = false;
    const {accept_terms_message} = getStaticText(this.props.activeLanguage);
    if (!this.state.terms) {
      this.createError('terms', accept_terms_message);
    } else {
      this.createError('terms', '');
      valid = true;
    }
    return valid;
  }

  handleFirstNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.firstName)) {
      this.createError('firstName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.firstName)) {
      this.createError('firstName', info_required_msg);
    } else {
      this.createError('firstName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleLastNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.lastName)) {
      this.createError('lastName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.lastName)) {
      this.createError('lastName', info_required_msg);
    } else {
      this.createError('lastName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleEmailIdBlur = () => {
    let email = this.state.emailId;
    let valid = false;
    const {email_id_required_msg, email_id_valid_msg} = getStaticText(this.props.activeLanguage);
    const {emailRegex} = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError('emailId', email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError('emailId', email_id_valid_msg);
    } else {
      this.createError('emailId', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handlePhoneNumberBlur = () => {
    let valid = false;
    const {phone_number_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.phoneNumber) || this.state.phoneNumber.length !== 7 || this.state.phoneNumber.includes(' ')
        || _.isEmpty(this.state.phoneNumberCode || this.state.phoneNumberCode.length !== 3 )) {
      this.createError('phoneNumber', phone_number_valid_msg);
    } else {
      this.createError('phoneNumber', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleSalaryBlur = () => {
    let valid = false;
    const {please_input_salary,please_input_min_salary} = getStaticText(this.props.activeLanguage);
    if (this.state.salary < 1 || this.state.salary === undefined) {
      this.createError('salary', please_input_salary);
    }else if(this.state.salary < 0){
      this.createError('salary', please_input_min_salary);
    } else {
      this.createError('salary', '');
      valid = true
    }
    return valid;
  }

  handleNationalityBlur = () => {
    let valid = false;
    const {nationality_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.nationality)) {
      this.createError('nationality', nationality_valid_msg);
    } else {
      this.createError('nationality', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  createError = (field, error) => {
    const errors = _.assign(this.state.errors, {[field]: error})
    this.setState({
      errors
    })
  }

  handleInputChange = (e, {value, name}) => {
    const {telephone} = getConst(this.props.activeLanguage);
    if(name === 'emailId'){
      value = value.trim();
    }
    if (name === 'phoneNumber') {
      if (telephone.test(value)) {
        this.setState({
          [name]: value
        })
      }
    } else {
      if(name === 'firstName' || name === 'lastName'){
        value = value.toUpperCase();
      }
      this.setState({
        [name]: value
      })
    }
  }

  handlePhoneNumberCode = (e, {value}) => {
    this.setState({phoneNumberCode: value})
  }

  closeAllApplyPopup = () => {
    const {applying_with_us} = getStaticText(this.props.activeLanguage);
    this.props.applySuccess(`${applying_with_us} <strong> ${this.props.data.applyCardObject.bankName} - ${this.props.data.applyCardObject.name}</strong>`, true);
    this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${this.props.data.applyCardObject.id}`);
    this.setState({
      terms: false,
      goodTimeToCall: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        nationality:'',
      }
    });
    this.close();
    this.props.data.closeDirectApplyPopup();

  }

  handleTimeToCall = (e, {value}) => {
    this.setState({goodTimeToCall: value});
  }

  handleNationality = (e, {value}) => {
    this.setState({nationality: value});
    this.createError('nationality', '');
  }

  handleMonthlySalaryChange = (value) => (this.setState({salary:value}));

  componentDidMount(){
    if(this.props.applyInputForm){
      console.log("Input  Props:", this.props.applyInputForm);
    this.setState({
      firstName: this.props.applyInputForm.firstName,
      lastName: this.props.applyInputForm.lastName,
      phoneNumberCode: this.props.applyInputForm.phoneNumberCode,
      phoneNumber: this.props.applyInputForm.phoneNumber,
      emailId: this.props.applyInputForm.emailId,
      salary: this.props.applyInputForm.salary,
      nationality: this.props.applyInputForm.nationality,
    });
  }
    if(this.props.simulateEmail){
      this.setState({emailId: this.props.simulateEmail});
      }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.applyInputForm !== nextProps.applyInputForm) {
      this.setState({
        errors: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailId: '',
          terms: '',
          salary: '',
          nationality: '',
        },
        terms: false,
      });
      this.setState({
        firstName: nextProps.applyInputForm.firstName,
        lastName: nextProps.applyInputForm.lastName,
        phoneNumberCode: this.props.applyInputForm.phoneNumberCode,
        phoneNumber: nextProps.applyInputForm.phoneNumber,
        emailId: nextProps.applyInputForm.emailId,
        salary: nextProps.applyInputForm.salary,
        nationality: nextProps.applyInputForm.nationality,
      });
    }
  }

  handleOpen = () => this.setState({ modalOpen: true })
  handleClose = () => this.setState({ modalOpen: false })
  fixBody() {
    const anotherModal = document.getElementsByClassName('ui page modals').length;
    if (anotherModal > 0) document.body.classList.add('scrolling', 'dimmable', 'dimmed');
  }

  handleSalaryInputChange = (e, {value, max}) => {
    const formatedValue = accounting.unformat(value)
    let validValue = formatedValue;
    if (max < formatedValue) {
      validValue = max;
    }
    this.setState({ salary: _.toNumber(validValue) })
  }

  onFocusField = (name) => {
    this.setState({onFocus: name})
  }

  digitValidate = (e) => {
    const re = /^[0-9.]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

 

  render() {
    
    var hiddenFields = document.querySelectorAll("input[type=hidden], input[type=text]");
    //alert("Lenght:", hiddenFields.length);
    for (var i=0; i<hiddenFields.length; i++) {
      var utmParam = sessionStorage.getItem(hiddenFields[i].name);
          var utmCampaign = sessionStorage.getItem("utm_campaign");
          
          var utmMedium = sessionStorage.getItem("utm_medium");
          
          var  utmSource = sessionStorage.getItem("utm_source");
          
          //document.getElementById("utm-source-hidden-field").value = 'hi';

          if (utmParam) {
            document.getElementsByName("utm_campaign")[0].value = utmCampaign;
            document.getElementsByName("utm_medium")[0].value = utmMedium;
            document.getElementsByName("utm_source")[0].value = utmSource;
          }
          
          // console.log("what is this:",document.getElementById("utm-source-hidden-field").value = 'hi')
          // if (utmParam) {document.getElementById("utm-source-hidden-field").value = sessionStorage.getItem(hiddenFields[i].name);
          
          // }
          
    }
   
    const lang = getStaticText(this.props.activeLanguage);
    console.log("Applycardobject:", this.props.data.applyCardObject);
    const {goodTimeToCall, phoneNumberCode} = getConst(this.props.activeLanguage);
    return (
      <Modal className='modal-apply' open={this.props.data.popupOpen} onClose={this.props.data.applyCardObject.contract ? this.showConfirm : () =>{this.props.data.closeDirectApplyPopup()}} closeOnEscape={false} closeOnRootNodeClick={false} closeIcon={false}>
        {/* <Modal.Header> */}
          {/* <img className='img-responsive show-for-desktop' alt={lang.soul_wallet} src='https://soulwallet.imgix.net/static-compressed/sw_logo-w.png?auto=compress' />
          <img className="img-responsive show-for-small" alt={lang.soul_wallet} src='https://soulwallet.imgix.net/static-compressed/sw_logo-small.png?auto=compress' /> */}
          {/* <h3 className='modal-title'>{lang.apply_online}</h3> */}
        {/* </Modal.Header> */}
        <Modal.Content> 
        <div className='modal-content apply-content'>
         {/* <Button onClick={this.showConfirm} id='applynow-application' icon='remove' color='grey' size='small'/> */}
       {/* <Icon className='applynow-application-close-icon' onClick={this.showConfirm} name="remove"/> */}
       <img src="https://soulwallet.imgix.net/static-compressed/assets/home/close-new.png?auto=compress&fm=webp%7Cauto=compress" 
        alt= "close"
          className="applynow-application-close-icon"
          onClick={this.showConfirm}/>
        
          {
          this.props.data.applyCardObject.contract ?
            <Segment.Group horizontal>
              <Segment>
                <div className='apply-content-img'>
                 <h3 className='modal-title hide-for-xs'>{lang.apply_online}</h3>
                 
                  <Image alt={this.props.data.applyCardObject.bankName+" "+this.props.data.applyCardObject.name} className='img-responsive' src={this.props.data.applyCardObject.logo} />
                </div>
                <div className="apply-bank-name">
                <h3 className='bank-name'>{this.props.data.applyCardObject.bankName}
                  <span className='card-name'>{this.props.data.applyCardObject.name}</span>
                </h3>
                </div>
                {/* <h3 className='card-name'>{this.props.data.applyCardObject.name}</h3> */}
                <div className="fee-div">
                  <p className='amount-list hide-for-xs'><span className='label'>{lang.minimum_salary} </span> <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumSalary, `${lang.aed} `, 0)}</span></p>
                  <Grid className="show-for-xs hide-for-desktop">
                        <Grid.Row columns={2}>
                          <Grid.Column>
                          <span className='label'>{lang.minimum_salary}</span>
                          </Grid.Column>
                          <Grid.Column>
                          <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumSalary, `${lang.aed} `, 0)}</span>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                {
                  this.props.data.applyCardObject.minimumBalance && this.props.data.applyCardObject.minimumDeposit?
                  <React.Fragment>
                    <React.Fragment>
                    <p className='amount-list hide-for-xs'><span className='label'>{lang.min_balance} </span> <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumBalance, `${lang.aed} `, 0)}</span></p>
                    <p className='amount-list hide-for-xs'><span className='label'>{lang.min_deposit} </span> <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumDeposit, `${lang.aed} `, 0)}</span></p>
                    </React.Fragment>
                    <React.Fragment>
                      <Grid className="show-for-xs hide-for-desktop">
                        <Grid.Row columns={2} className="product-grid-row">
                          <Grid.Column>
                            <span className='label'>{lang.min_balance}</span>
                          </Grid.Column>
                          <Grid.Column>
                            <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumBalance, `${lang.aed} `, 0)}</span>
                          </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={2}>
                          <Grid.Column>
                            <span className='label'>{lang.min_deposit}</span>
                          </Grid.Column>
                          <Grid.Column>
                            <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.minimumDeposit, `${lang.aed} `, 0)}</span>
                          </Grid.Column>
                        </Grid.Row>

                      </Grid>
                      </React.Fragment>
                  </React.Fragment>
                  :
                  this.props.data.applyCardObject.annualFee>=0 && this.props.data.applyCardObject.profitRate?
                  <React.Fragment>
                    <React.Fragment>
                      <p className='amount-list hide-for-xs'><span className='label'>{lang.annual_fee}</span> <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.annualFee, `${lang.aed} `, 0)}</span></p>
                      <p className='amount-list hide-for-xs'><span className='label'>{lang.rate}</span> <span className='value'>{this.props.data.applyCardObject.profitRate}</span></p>
                    </React.Fragment>
                    <React.Fragment>
                      <Grid className="show-for-xs hide-for-desktop">
                        <Grid.Row columns={2} className="product-grid-row">
                            <Grid.Column>
                              <span className='label'>{lang.annual_fee}</span>
                            </Grid.Column>
                            <Grid.Column>
                              <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.annualFee, `${lang.aed} `, 0)}</span> 
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                              <span className='label'>{lang.rate}</span>
                            </Grid.Column>
                            <Grid.Column>
                              <span className='value'>{this.props.data.applyCardObject.profitRate}</span> 
                            </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </React.Fragment>
                  </React.Fragment>
                  :
                  this.props.data.applyCardObject.fixedRate>=0 && this.props.data.applyCardObject.reducingRate>=0 && this.props.data.applyCardObject.maxLoanAmount>=0?
                  <React.Fragment>
                    <React.Fragment>
                    <p className='amount-list hide-for-xs'><span className='label'>{[773, 394].includes(this.props.data.applyCardObject.id)? "Finance Amount" : lang.loan_amount}</span> <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.maxLoanAmount, `${lang.aed} `, 0)}</span></p>
                    <p className='amount-list hide-for-xs'><span className='label'>{lang.fixed_rate}</span> <span className='value'>{this.props.data.applyCardObject.fixedRate +'%'}</span></p>
                    <p className='amount-list hide-for-xs'><span className='label'>{lang.reducing_rate}</span> <span className='value'>{this.props.data.applyCardObject.reducingRate+'%'}</span></p>
                    <p className='amount-list hide-for-xs'><span className='label'>{lang.down_payment}</span> <span className='value'>{this.props.data.applyCardObject.downPayment+'%'}</span></p>
                    </React.Fragment> 
                    <React.Fragment>
                      <Grid className="show-for-xs hide-for-desktop">
                        <Grid.Row columns={2} className="product-grid-row">
                          <Grid.Column>
                          <span className='label'>{lang.loan_amount}</span>
                          </Grid.Column>
                          <Grid.Column>
                          <span className='value'>{accounting.formatMoney(this.props.data.applyCardObject.maxLoanAmount, `${lang.aed} `, 0)}</span>
                          </Grid.Column>
                        </Grid.Row>
                      
                        <Grid.Row columns={2} className="product-grid-row">
                          <Grid.Column>
                            <span className='label'>{lang.fixed_rate}</span>
                          </Grid.Column>
                          <Grid.Column>
                            <span className='value'>{this.props.data.applyCardObject.fixedRate +'%'}</span>
                          </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={2} className="product-grid-row">
                          <Grid.Column>
                            <span className='label'>{lang.reducing_rate}</span>
                          </Grid.Column>
                          <Grid.Column>
                            <span className='value'>{this.props.data.applyCardObject.reducingRate+'%'}</span>
                          </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={2}>
                          <Grid.Column>
                            <span className='label'>{lang.down_payment}</span>
                          </Grid.Column>
                          <Grid.Column>
                            <span className='value'>{this.props.data.applyCardObject.downPayment+'%'}</span>
                          </Grid.Column>
                        </Grid.Row>

                      </Grid>
                    </React.Fragment>
                  </React.Fragment>
                  
                  :
                  ''
                }
                
                
                </div>
                {_.has(this.props.data.applyCardObject, 'annualSave')?
                
                  <p className='amount-list'>
                    <span className='label left'>{lang.annual_save}<Icon onClick={this.handleOpen} name='info circle' /></span>
                    <div className='right text-right mar-0'>
                      {/* <span className='placeholder'>{lang.you_save}</span> */}
                      <span className='text-bold'>{accounting.formatMoney(this.props.data.applyCardObject.annualSave, `${lang.aed} `, 0)} </span>
                      {/* <span className='placeholder'>{lang.per_year}</span> */}
                  </div>
                  </p>:
                  <p />
                  
                }
                <div className='clearfix'></div>
                <div className="apply-top-reasons">
                <h3 className='modal-content-subtitle'>{lang.top_reason_to_choose}</h3>
                {_.isEmpty(this.props.data.applyCardObject.topReasons)?<span />:
                  this.props.data.applyCardObject.topReasons.map((item, idx) => (
                    <ul className='list-check' key={idx}>
                      <li>{_.upperFirst(item)}</li>
                    </ul>
                ))}
                </div>
              </Segment>
              <Segment>
                {
                  this.props.data.applyCardObject.contract ?
                  <p className="online-dcp">{lang.apply_online_description}</p>
                :
                  // <p >{lang.contract_description}</p>
                  <p>{lang.apply_online_description}</p>
                }

                <Form className='custom-form' id='apply-form'>  
                  <div className='form-control'>
                    <span className={!_.isEmpty(this.state.firstName) || this.state.onFocus === 'firstName'?'label-animate active': 'label-animate'}>{lang.first_name} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.firstName}
                      onBlur={this.handleFirstNameBlur}
                      name='firstName'
                      onChange={this.handleInputChange}
                      maxLength={30}
                      onFocus={(value) => this.onFocusField('firstName')}
                    />
                    <span className='input-error'>{this.state.errors.firstName}</span>
                  </div>
                  <div className='form-control'>
                    <span className={!_.isEmpty(this.state.lastName) || this.state.onFocus === 'lastName'?'label-animate active':'label-animate'}>{lang.last_name} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.lastName}
                      onBlur={this.handleLastNameBlur}
                      name='lastName'
                      onChange={this.handleInputChange}
                      maxLength={30}
                      onFocus={(value) => this.onFocusField('lastName')}
                    />
                    <span className='input-error'>{this.state.errors.lastName}</span>
                  </div>
                  <div className='form-control'>
                    <span className={!_.isEmpty(this.state.emailId) || this.state.onFocus === 'emailId'?'label-animate active':'label-animate'}>{lang.email_id} <span className='asterik'>*</span></span>
                    <Form.Input
                      value={this.state.emailId}
                      onBlur={this.handleEmailIdBlur}
                      name='emailId'
                      onChange={this.handleInputChange}
                      maxLength={50}
                      onFocus={(value) => this.onFocusField('emailId')}
                    />
                    <span className='input-error'>{this.state.errors.emailId}</span>
                  </div>
                  <div className='form-control direct-apply--opt choose-time direct-apply--opt choose-time applynow-only'>
                    
                    <Dropdown
                      value={this.state.goodTimeToCall}
                      selection
                      options={goodTimeToCall}
                      onChange={this.handleTimeToCall}
                      search={false}
                      id='goodtimecall'
                      //placeholder={lang.select}
                      placeholder="Good time To Call"
                      disabled
                    />
                  </div>
                  <div className='form-control'>
                    <span className={!_.isEmpty(this.state.phoneNumber) || this.state.onFocus === 'phoneNumber'?'label-animate active top-0':'label-animate top-0'}><span className='asterik'></span></span>
                    <div className='phone-number-wrap'>
                      <span>+971</span>
                      <div className='label'>
                      <Dropdown
                          value={this.state.phoneNumberCode}
                          selection
                          options={phoneNumberCode}
                          onChange={this.handlePhoneNumberCode}
                          search={false}
                          id='codelabel'
                        />
                      </div>
                      <div className='field-phone-number'>
                      <Form.Input
                          value={this.state.phoneNumber}
                          placeholder={`${lang.ex}: 8989899`}
                          onBlur={this.handlePhoneNumberBlur}
                          name='phoneNumber'
                          type='tel'
                          pattern='[0-9]{7}'
                          onChange={this.handleInputChange}
                          maxLength={7}
                          onFocus={(value) => this.onFocusField('phoneNumber')}
                          onKeyPress={this.digitValidate}
                        />
                      </div>
                    </div>
                    {
                      (this.state.phoneNumberCode==='' || this.state.phoneNumber==='' || _.size(this.state.phoneNumber)!==7)?
                      <span className='input-error'>{this.state.errors.phoneNumber}</span>:''
                    }
                    
                  </div>
                  
                  <div className='form-control choose-time direct-apply--opt-nat applynow-only'>
                    <p>Nationality*</p>
                    <Dropdown
                      value={this.state.nationality}
                      selection
                      options={nationality}
                      onChange={this.handleNationality}
                      search={true}
                      id='goodtimecall'
                      placeholder={lang.select}

                    />
                     <span className='input-error'>{this.state.errors.nationality}</span>
                  </div>
                  <div className='form-control direct-apply--salary good-call applynow-only'>
                    <span className="pad-1">{lang.monthly_salary}<span className='asterik'>*</span></span>
                    {/*<Slider
                      step={this.state.salary < ((60/100)*200000) ? 500
                       :
                       (this.state.salary >= ((60/100)*200000)) ?  2000
                       :
                       2000}
                      value={this.state.salary}
                      min={0}
                      max={200000}
                      onChange={this.handleMonthlySalaryChange}
                      className='rc-slider--yellow'
                    />*/}
                    <Form.Input
                      onChange={this.handleSalaryInputChange}
                      value={this.state.salary>0?`${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)}`:''}
                      max={200000}
                     placeholder={lang.aed_5000}
                      type='tel'
                      pattern='[0-9]*'
                      onBlur={this.handleSalaryBlur}
                      className='has-price-format margin-btm-0'
                      onKeyPress={this.digitValidate}
                    />
                    <span className='input-error'>{this.state.errors.salary}</span>
                  </div>
                  <input type="hidden" id="utm-source-hidden-field" name="utm_source" value={utmSource===null?'Nil':utmSource} />
                  <input type="hidden" id="utm-medium-hidden-field" name="utm_medium" value={utmMedium===null?'Nil':utmMedium} />
                  <input type="hidden" id="utm-campaign-hidden-field" name="utm_campaign" value={utmCampaign===null?'Nil':utmCampaign}/>
                  <div className='self-em form-control '>
                    <Form.Checkbox checked={this.state.selfEmployed} onClick={this.handleSelfEmployed} required label='' className='display-inline-block left unasterik'></Form.Checkbox>
                    <label className='width-90 display-inline-block self_emp_label_direct_apply'>{lang.self_em}</label>
                  </div>
                   {/* <div className='form-control choose-time direct-apply--opt-nat applynow-only'>
                    <p>Income Type*</p>
                    <Dropdown
                      value={this.state.selfEmployed}
                      selection
                      options={incomeType}
                      onChange={this.handleSelfEmployed}
                      id='goodtimecall'
                    />
                     <span className='input-error'>{this.state.errors.incomeType}</span>
                  </div> */}
                  <div className='form-control padding-top-0 direct-apply--terms'>
                    <Form.Checkbox checked={this.state.terms} onClick={this.handleTerms} required label='' className=' unasterik'></Form.Checkbox>
 
                    {
                      this.props.data.applyCardObject.bankName === 'Citibank'?
                      <label className="citi-label">{lang.citi_disclaimer}
                      <p>Credit Bureau Consent, Welcome Offer & General Terms & Conditions
                      <Popup
                          trigger={<Icon name="info" />}
                          content={lang.credit_bureau}
                          size='tiny'
                          wide='very'
                          position='left center'
                          basic
                          on='click'
                      /> </p> 
                      {/* <p>Authorization to request Account Statement from Central Bank
                      <Popup
                        trigger={<Icon name="info" />}
                        content={lang.authorization}
                        basic
                        wide
                        on='click'
                        /></p> */}
                      </label>:
                      this.props.data.applyCardObject.bankName === 'deem'?
                      <label className="citi-label">{lang.deem_disclaimer}
                      <Popup
                          trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                          content={lang.deem_popup}
                          size='tiny'
                          wide='very'
                          position='left center'
                          basic
                          on='click'
                      />
                      </label>:
                      
                      <label className='width-90 display-inline-block'>
                        {lang.apply_terms} I confirm that I have read and agree to Soulwallet Portal LLC’s <a href='/terms-and-conditions' target="_blank">Terms</a> and <a href='/privacy-policy' target="_blank"> Privacy Policy</a>.
                        {this.props.data.applyCardObject.name === 'Citigold'?
                        <p className="citi-label">{lang.citi_gold_new_disclaimer}
                        <Popup
                            trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                            content={lang.citi_gold_popup}
                            size='tiny'
                            wide='very'
                            position='left center'
                            basic
                            on='click'
                        />
                        </p>
                        :
                        this.props.data.applyCardObject.bankName === 'Citi'?
                        <p className="citi-label">{lang.citi_new_disclaimer}
                        <Popup
                            trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                            content={lang.citi_popup}
                            size='tiny'
                            wide='very'
                            position='left center'
                            basic
                            on='click'
                        />
                        </p>:''}
                      </label>
                     }
                     {
                       this.state.terms===false?
                       <span className='input-error'>{this.state.errors.terms}</span>:''
                     }
                    
                  </div>
                </Form>
                {
          this.props.data.applyCardObject.contract ?
          <div className='direct-footer'>
            {/* <Button className='btn btn-applycancel hide-for-xs' type='reset' onClick={this.showConfirm}>{lang.cancel}</Button> */}
            <Button className='btn btn-blue right' id='submit-application' onClick={()=>this.finalCardApply(utmSource,utmMedium,utmCampaign)}>{lang.apply}</Button>
            </div>
          :
          ""
          }
              </Segment>
            </Segment.Group>
            :
            <Segment.Group horizontal>
              <Segment>
                <h1 className='margin-left-m-20 non-contract'>{lang.non_contract_alert} <a className="click-here" onClick={()=>{this.props.suggest(this.state.maxSalary)}}>{lang.click_here}</a></h1>
              </Segment>
            </Segment.Group>
           }
          <Modal open={this.state.openApplyResponsePopup} size='mini' onClose={this.close}>
            <Modal.Header>
              {lang.apply_card_response}
            </Modal.Header>
            <Modal.Content>
              <p>{this.state.applyMessage}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button positive onClick={this.closeAllApplyPopup} icon='checkmark' content={lang.view_more} />
            </Modal.Actions>
          </Modal>

           
          </div>
        
        </Modal.Content>
        <Modal open={this.state.modalOpen} onClose={this.handleClose} className='iterms-modal'>
      <Modal.Content>
        <Button onClick={this.handleClose} icon='close icon' />
        <ul>
          <li>The annual save amount is mentioned based on the specific values input in the savings simulator pop-up</li>
          <li>The annual save amount is based only on the loyalty rewards offered to customers on various credit cards (cashback, rewards, air miles etc.)</li>
          <li>The annual save amount does not include value associated with other features such as airport lounge offers, cinema ticket offers, saves from various discounts and so on</li>
          <li>The annual save value shown does not always take into account spend made at specific merchant establishments which, in some instances, may entitle the customer to increased savings based on the particular credit card’s loyalty reward feature product offering</li>
          <li>Annual values shown are indicative values only that are calculated on a best effort basis and are not meant to represent the most accurate calculation of rewards and can vary significantly for various reasons</li>
          <li>Please refer to detailed Terms & Conditions</li>
        </ul>
      </Modal.Content>
    </Modal>
     <Modal open={this.state.openConfirmPopup} onClose={this.handleClose} className='cancel-confirm'>
      <Modal.Content>
      <div>
        <p style={{textAlign:"center"}}> Are you sure you want to exit?</p>
        <Button className='btn btn-white-exit' type='reset' onClick={this.handleCancel}>{lang.no}</Button>
        <Button className='btn btn-blue-exit right' onClick={this.handleConfirm}>{lang.yes}</Button>
      </div>  
      </Modal.Content>
    </Modal>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  applyInputForm: state.applyInputForm,
  activeLanguage: state.activeLanguage,
  simulateEmail: state.simulateEmail.email,
});

const mapDispatchToProps = {
  applySuccess,
  storeSimulateEmail,
  storeApplyFormInput,
};

const ApplyCardContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DirectApply));

export default ApplyCardContainer;



// WEBPACK FOOTER //
// ./src/components/applyForm/directapply.js